import { Device, from } from '@helpers/media';
import { css } from 'styled-components';
import { fluid } from './fluid';
export const SitePadding = 18;
export const SiteWidth = 1240;
export const SiteWidthBreakpoint = SiteWidth + SitePadding * 2;
export const siteWide = css `
  --sitePadding: ${SitePadding}px;
  --siteWidth: ${SiteWidth}px;
  --maxWidth: calc(var(--siteWidth) + (var(--sitePadding) * 2));

  margin: 0 auto;
  padding: 0 var(--sitePadding);
  width: 100%;

  @media ${from(Device.TabletLarge)} {
    width: min(calc(75% + (var(--sitePadding) * 2)), var(--maxWidth));
  }
`;
export const baseGrid = css `
  --gutterWidth: ${fluid(10, 40)};

  display: grid;
  column-gap: var(--gutterWidth);
  grid-template-columns: repeat(12, 1fr);
`;
